import { render, staticRenderFns } from "./Regex.vue?vue&type=template&id=a4901a06&scoped=true&"
import script from "./Regex.vue?vue&type=script&lang=js&"
export * from "./Regex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4901a06",
  null
  
)

export default component.exports